<template>
  <div
    class="transition-all duration-500 p-3 hover:shadow-[0_0_8px_rgba(0,0,0,0.3)] rounded-md bg-white shadow-[0_0.3em_0.3em_-0.3em_hsla(0,0%,4%,0.1),0_0_0_0.1rem_hsla(0,0%,4%,0.08)] flex items-center justify-center dark:hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] dark:[box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)]"
  >
    <NuxtImg
      :src="img"
      :alt="alt"
      width="128"
      height="128"
      class="min-w-max"
      loading="lazy"
      format="webp"
    />
  </div>
</template>

<script setup>
defineProps({
  img: {
    String,
    default: "/images/icon-saas-g-suite.webp",
  },
  alt: { String, default: "default alt" },
});
</script>

<style lang="scss" scoped></style>
